import React, { useState, useEffect, useCallback } from "react";
import styled, { withTheme } from "styled-components";
import { AUDIT_TRAIL_MAX_LENGTH_FILTER_INPUT } from "../../../../modules/constants";
import PrimaryButton from "../../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import LabelledInput from "../../../ui-library/LabelledInput/LabelledInput";
import CustomPopover from "../../../ui-library/CustomPopover/CustomPopover";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const FormActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
`;

const ActorFilterForm = (props) => {
  const { show, onClose, onSubmit, currentFilterActor, target } = props;

  const [filterActor, setFilterActor] = useState("");

  useEffect(() => {
    setFilterActor(currentFilterActor ?? "");
  }, [currentFilterActor]);

  const handleOnClose = useCallback(() => {
    onClose();
    setFilterActor(currentFilterActor ?? "");
  }, [onClose, currentFilterActor]);

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      onSubmit(filterActor);
    }
  };

  return (
    <CustomPopover
      show={show}
      target={target}
      onClose={handleOnClose}
      title="Filter by"
    >
      <FormContainer data-testid="actor-filter-form">
        <LabelledInput
          title="Actor"
          value={filterActor}
          type="text"
          autoFocus={true}
          onChange={(e) =>
            e.target.value.length <= AUDIT_TRAIL_MAX_LENGTH_FILTER_INPUT &&
            setFilterActor(e.target.value)
          }
          data-testid="atf-actor-input"
          onKeyDown={onKeyDown}
        />
        <FormActionButtonsContainer>
          <PrimaryButton
            data-testid="actor-filter-modal-submit-button"
            size="sm"
            onClick={() => {
              onSubmit(filterActor);
            }}
          >
            Apply
          </PrimaryButton>
        </FormActionButtonsContainer>
      </FormContainer>
    </CustomPopover>
  );
};

export default withTheme(ActorFilterForm);
